<ng-template #helpCenter></ng-template>
<header class="header">
  <div class="navigation" [class.is-collapse]="showMenu">
    <div class="container">
      <div class="header-flex">
        <app-logo-with-partner-referer data-test="logoPartner" [variationLogo]="variation_logo" />
        <div
          class="d-flex header-menu-icons pl-1"
          [class.mr-1]="platformcode !== 'ar'"
          [class.partner]="isPartnersite">
          @if (!isMobile) {
            @defer (on idle) {
              <app-geo-ip-switcher />
            }
          }
          <!-- hotline -->
          <a
            data-test="hotlineLink"
            [title]="'ALPY_HEADER.hotline' | alpitranslate"
            class="header-dropdown-block header-link m-0"
            href="tel:{{ hotline }}">
            <span class="header-text d-none d-lg-inline-block"
              >{{ 'ALPY_HEADER.hotline' | alpitranslate }} {{ hotline }}</span
            >
            <app-icon name="phone" class="text-primary" />
          </a>
          <!-- language switcher -->
          <div class="header-dropdown-block header-dropdown-block-language dropdown-block">
            <div
              class="header-dropdown-text dropdown-trigger c-pointer"
              (click)="isLangSwitcherOpen = true"
              data-test="languageSwitcher">
              <span class="header-text d-none d-lg-block mr-2">{{
                'ALPY_HEADER.preferredLanguage' | alpitranslate
              }}</span>
              <div class="dropdown-trigger dropdown-trigger-changing">
                <span class="d-none d-lg-block">{{
                  platformInformationService.selectionNames[currentLang]
                }}</span>
                <img
                  width="17"
                  height="17"
                  class="img-responsive"
                  src="{{ 'images/languages/AR_lang_' + currentLang + '.svg' | platformasset: true }}"
                  alt="{{ currentLang }}" />
              </div>
            </div>
            @if (isLangSwitcherOpen) {
              @defer (when isLangSwitcherOpen) {
                <app-language-switcher
                  (clickOutside)="isLangSwitcherOpen = false"
                  [currentLang]="currentLang"
                  [acceptedLanguages]="acceptedLanguages"
                  @collapsible />
              }
            }
          </div>
          <!-- currency switcher -->
          @if (showCurrencySwitcher) {
            <div class="header-dropdown-block">
              <div (click)="isCurrencySwitcherOpen = true" data-test="currencySwitcher" class="c-pointer">
                <span class="header-text d-none d-lg-inline-block mr-2">
                  {{ 'ALPY_HEADER.chooseCurrency' | alpitranslate }}
                </span>
                <span class="currency-symbol" style="vertical-align: middle">{{
                  currencyService.actualCurrency
                }}</span>
              </div>
              @if (isCurrencySwitcherOpen) {
                @defer (when isCurrencySwitcherOpen) {
                  <app-currency-switcher
                    [acceptedCurrencies]="acceptedCurrencies"
                    (clickOutside)="isCurrencySwitcherOpen = false"
                    @collapsible />
                }
              }
            </div>
          }
          <!-- "burger" menu icons -->
          @if (platformcode === 'ar' && !isPartnersite) {
            <span data-test="mobileBurgerMenu" class="navigation-trigger" (click)="toggleMenu()">
              <span class="navigation-trigger-icon"></span>
            </span>
          }
        </div>
      </div>
      @if (platformcode === 'ar' && !isPartnersite) {
        <nav class="nav-collapse" [@flyInOutMenu]="showMenu ? 'in' : 'out'">
          <div class="header-bottom desktop-bottom" (deferLoad)="initNav()">
            <ng-container #desktopNav></ng-container>
          </div>
        </nav>
      }
    </div>
  </div>
</header>
